import { useState, useRef } from 'react'
import { Form } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { Icon } from '@/ui'
import { useLocaleSettings } from '@/hooks'
import { StyledNumberFormat } from './Styles'
import { NumberProps } from './types'

const Number = ({
  onChange,
  onFormattedValueChange,
  error,
  clearable,
  locale,
  sensitive,
  disabled,
  value,
  onSensitiveToggle,
  displayType,
  useThousandSeparator,
  decimalScale,
  formatNumber,
  ...rest
}: NumberProps) => {
  const { t } = useTranslation()
  const inputRef = useRef<HTMLInputElement>(null)
  const [visible, setVisible] = useState(false)
  const settings = useLocaleSettings(locale)

  const Input =
    sensitive && !visible ? (
      <Form.Input disabled={disabled} value="**********" />
    ) : (
      <Form.Input disabled={disabled}>
        <StyledNumberFormat
          valueIsNumericString
          key={visible ? 1 : 2}
          type={formatNumber ? 'tel' : 'text'}
          getInputRef={inputRef}
          disabled={(sensitive && !visible) || disabled}
          canRead={!disabled}
          decimalSeparator={settings?.decimalSeparator}
          thousandSeparator={
            useThousandSeparator ? settings?.thousandSeparator : undefined
          }
          thousandsGroupStyle={settings?.thousandsGroupStyle}
          decimalScale={decimalScale}
          error={error}
          onValueChange={values => {
            const { value, formattedValue } = values

            if (onChange) {
              onChange(value)
            }

            if (onFormattedValueChange) {
              onFormattedValueChange(formattedValue)
            }
          }}
          value={value}
          displayType={displayType}
          formatNumber={formatNumber}
          {...rest}
        />
      </Form.Input>
    )

  if (sensitive) {
    return (
      <div style={{ position: 'relative' }} title={t('Edit content')}>
        {Input}
        <Icon
          button
          size="big"
          name={visible ? 'icon-sensitive-off' : 'icon-sensitive-on'}
          onClick={e => {
            onSensitiveToggle?.(e, !visible)
            setVisible(!visible)

            if (!visible) {
              setTimeout(() => {
                inputRef.current?.focus()
              }, 0)
            }
          }}
          style={{
            position: 'absolute',
            right: '8px',
            top: '8px',
          }}
        />
      </div>
    )
  }

  return Input
}

export default Number
